import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index'
import Login from '@/pages/Login'
import Register from '@/pages/Register'
import PaymentResult from '@/pages/PaymentResult.vue'

// 导入相关路由配置
import mainpageRoutes from './mainpage.js'
// 导入用户中心路由配置
import ucenterRoutes from './ucenter.js'
// 导入商品相关路由配置
import goodsRoutes from './goods.js'
// 导入案例分享路由配置
import caseshareRoutes from './caseshare.js'
// 导入资讯中心路由配置
import articleRoutes from './article.js'
// 导入订单中心路由配置
import orderRoutes from './order.js'


Vue.use(Router)

export default new Router({
  routes: [
    // 合并相关路由
    ...mainpageRoutes,
    // 合并用户中心路由
    ...ucenterRoutes,
    // 合并商品相关路由
    ...goodsRoutes,
    // 合并案例分享路由
    ...caseshareRoutes,
    // 合并资讯中心路由
    ...articleRoutes,
    // 合并订单中心路由
    ...orderRoutes,

    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'Index',
      component: Index,
      meta: {
        title: '首页'
      }
    },

    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: '登录/注册'
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {
        title: '注册'
      }
    },
    {
      path: '/payment-result',
      name: 'PaymentResult',
      component: PaymentResult,
      meta: {
        title: '支付结果'
      }
    },
    {
      path: '/package',
      name: 'Package',
      // 暂时使用Index组件，实际项目中应该创建Package组件
      component: Index,
      meta: {
        title: '会议套餐'
      }
    },

    {
      path: '/logout',
      name: 'Logout',
      // 登出路由，重定向到首页
      redirect: '/index'
    },
    {
      path: '/contact',
      name: 'Contact',
      // 暂时使用Index组件，实际项目中应该创建Contact组件
      component: Index,
      meta: {
        title: '联系我们'
      }
    },
    // Footer中新增的路由
    {
      path: '/booth',
      name: 'Booth',
      // 暂时使用Index组件，实际项目中应该创建Booth组件
      component: Index,
      meta: {
        title: '展位搭建'
      }
    },
    {
      path: '/planning',
      name: 'Planning',
      // 暂时使用Index组件，实际项目中应该创建Planning组件
      component: Index,
      meta: {
        title: '活动策划'
      }
    },
    {
      path: '/audio-visual',
      name: 'AudioVisual',
      // 暂时使用Index组件，实际项目中应该创建AudioVisual组件
      component: Index,
      meta: {
        title: '视听设备'
      }
    },
    {
      path: '/furniture',
      name: 'Furniture',
      // 暂时使用Index组件，实际项目中应该创建Furniture组件
      component: Index,
      meta: {
        title: '活动家具'
      }
    },
    {
      path: '/materials',
      name: 'Materials',
      // 暂时使用Index组件，实际项目中应该创建Materials组件
      component: Index,
      meta: {
        title: '材料租赁'
      }
    },
    {
      path: '/props',
      name: 'Props',
      // 暂时使用Index组件，实际项目中应该创建Props组件
      component: Index,
      meta: {
        title: '道具租赁'
      }
    },
    {
      path: '/privacy',
      name: 'Privacy',
      // 暂时使用Index组件，实际项目中应该创建Privacy组件
      component: Index,
      meta: {
        title: '隐私政策'
      }
    },
    {
      path: '/terms',
      name: 'Terms',
      // 暂时使用Index组件，实际项目中应该创建Terms组件
      component: Index,
      meta: {
        title: '用户协议'
      }
    },
    // 404路由，必须放在最后
    {
      path: '*',
      name: 'NotFound',
      component: () => import('@/pages/NotFound.vue'),
      meta: {
        title: '页面不存在'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js